import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "with_white_bg rad8 pad10"
}
const _hoisted_2 = {
  class: "w100 addressbookSearchBox posRe",
  style: {"margin-top":"-10px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "w100"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "ofs w100"
}
const _hoisted_18 = {
  key: 0,
  class: "fw600 w100 pad10"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  class: "centered",
  style: {"margin-top":"30px"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "アドレス帳に登録がありません。", -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 3,
  class: "w100",
  style: {"border":"1px solid #efefef"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { width: "400" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  class: "pointer w100 pad10 border rad10",
  style: {"border":"1px solid #ddd"}
}
const _hoisted_29 = { class: "w100" }
const _hoisted_30 = { class: "fl" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "dblueBg padw5 pointer rad8 mt2 fs12 fw600 mr10" }, "グループ", -1)
const _hoisted_32 = {
  key: 0,
  class: "mt3 ml5"
}
const _hoisted_33 = { class: "fl" }
const _hoisted_34 = { class: "fs16 fw600 mt3" }
const _hoisted_35 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_36 = {
  key: 0,
  class: "fr",
  style: {"width":"40px"}
}
const _hoisted_37 = {
  style: {"width":"35px","margin-right":"5%"},
  class: "fr"
}
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "fs14 fw600 pad10",
  style: {"width":"calc(100% - 30px)"}
}
const _hoisted_44 = { class: "fl" }
const _hoisted_45 = {
  key: 0,
  class: "fs10"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "grey fs9" }
const _hoisted_48 = {
  key: 0,
  class: "fl mr5 mt2"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 0,
  class: "fr",
  style: {"width":"160px"}
}
const _hoisted_51 = {
  style: {"width":"35px","margin-right":"5%"},
  class: "fr"
}
const _hoisted_52 = ["src", "onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"5px","margin-left":"-3px"} }, " 編集", -1)
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "w100 pad10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_AttendeeForm = _resolveComponent("AttendeeForm")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_AttendeeEditModal = _resolveComponent("AttendeeEditModal")!
  const _component_ModalDeleteFromAddressBook = _resolveComponent("ModalDeleteFromAddressBook")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.permitAddressBook)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon.png`),
            width: "16",
            height: "17",
            class: "posAb",
            style: {"top":"11px","left":"10px"}
          }, null, 8, _hoisted_3),
          _createVNode(_component_TextfieldTag, {
            placeholder: "メールアドレス/名前/所属名から検索",
            style: {"height":"40px","min-width":"200px","border-radius":"20px","text-indent":"1.5em","max-width":"280px"},
            class: "fl fs14 roundForm mr10 searchAddressbookField w100",
            value: _ctx.searchText,
            onInputValue: _ctx.inputSearchText,
            onKeyup: _withKeys(_ctx.startSearch, ["enter","native"])
          }, null, 8, ["value", "onInputValue", "onKeyup"]),
          (_ctx.searchedCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
                  width: "24",
                  height: "24",
                  class: "pointer mt7",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSearchText && _ctx.resetSearchText(...args)))
                }, null, 8, _hoisted_5)
              ]))
            : (_ctx.searchText?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "fl dblueBg padw7 pointer hoverGreyBg rad8 mt2",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchInAddressBook && _ctx.searchInAddressBook(...args)))
                  }, "検索")
                ]))
              : _createCommentVNode("", true),
          _hoisted_7
        ]),
        _createVNode(_component_SelectTag, {
          name: "select_category",
          id: "select_category",
          class: _normalizeClass(`fl header_title fs14 ls1 fw600 pointer mr5`),
          options: [`カテゴリ検索`, `グループ以外`, `カレンダー連携済`, `登録メンバー`],
          defaultOption: `カテゴリ検索`,
          onSelectValue: _ctx.selectCategory
        }, null, 8, ["onSelectValue"]),
        _hoisted_8,
        (_ctx.showNewButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", {
                class: "circle_button skyblueBg hoverGreyBg fw600 fs14 fr centered",
                style: {"width":"80px","padding":"6px 12px","margin-top":"-6px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openForm && _ctx.openForm(...args)))
              }, [
                (_ctx.isOpenForm)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "閉じる"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, " 新規 "))
              ]),
              _hoisted_12,
              _hoisted_13,
              (_ctx.isOpenForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_AttendeeForm, {
                      onUpdate: _ctx.addAttendeeFromAddressBook,
                      currentMember: _ctx.currentMember,
                      action: _ctx.editOrNewForm
                    }, null, 8, ["onUpdate", "currentMember", "action"]),
                    _hoisted_15,
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.permitAddressBook)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_ctx.searchedCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.searchedCount) + "件見つかりました", 1))
                : _createCommentVNode("", true),
              (!_ctx.displayMembers || _ctx.searching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_RoomsLoader)
                  ]))
                : (_ctx.displayMembers.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                          width: "40",
                          height: "40"
                        }, null, 8, _hoisted_23)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("table", _hoisted_24, [
                      _hoisted_25,
                      (!_ctx.hideGroups && _ctx.displayClgs && _ctx.viewType == `all`)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayClgs, (clg, clgindex) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${clgindex}`
                              }, [
                                _createElementVNode("td", {
                                  onClick: ($event: any) => (_ctx.selectGroupFromAddressBook(clg)),
                                  class: "pad10"
                                }, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _hoisted_31,
                                        (clg.total_num)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(clg.total_num) + "人登録", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("p", _hoisted_34, _toDisplayString(clg.name), 1),
                                        (clg.private_memo)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(clg.private_memo), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.editGroup)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _createElementVNode("div", _hoisted_37, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                                width: "22",
                                                height: "25",
                                                class: "fr pointer",
                                                onClick: ($event: any) => (_ctx.deleteGroupList(clg))
                                              }, null, 8, _hoisted_38), [
                                                [_directive_tooltip, `グループを削除します`]
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _hoisted_39
                                    ]),
                                    _hoisted_40
                                  ]),
                                  _hoisted_41
                                ], 8, _hoisted_27)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMembers, (user, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${index}${user.user_id}${_ctx.systemUpdatedAt}`,
                          height: "60",
                          class: _normalizeClass(`dataEmail`),
                          style: {"border-bottom":"1px solid #efefef","line-height":"45px"}
                        }, [
                          _createElementVNode("td", {
                            onClick: ($event: any) => (_ctx.selectFromAddressBook(user))
                          }, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("span", null, _toDisplayString(user.name), 1),
                                (user.company_name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "(" + _toDisplayString(user.company_name) + ")", 1))
                                  : _createCommentVNode("", true),
                                _hoisted_46,
                                _createElementVNode("div", _hoisted_47, [
                                  (!_ctx.Util.isSMSEmail(user.email))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.truncate(user.email, 25)), 1))
                                    : _createCommentVNode("", true),
                                  (user.calendar_tag)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_share.png`),
                                        width: "16",
                                        height: "15",
                                        class: "fl mt2"
                                      }, null, 8, _hoisted_49))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.showEditButton)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                                        width: "30",
                                        height: "30",
                                        class: "fr pointer",
                                        onClick: ($event: any) => (_ctx.showDeleteFromAddressBookModal(user))
                                      }, null, 8, _hoisted_52),
                                      _createTextVNode("   ")
                                    ]),
                                    _createElementVNode("label", {
                                      class: _normalizeClass(`circle_button fw400 fr centered fs12 blueAround`),
                                      style: {"width":"80px","padding":"4px 10px","margin-right":"10px"},
                                      onClick: ($event: any) => (_ctx.editUser(user))
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                                        width: "14",
                                        height: "14",
                                        style: {"margin-top":"-3px"}
                                      }, null, 8, _hoisted_54),
                                      _hoisted_55
                                    ], 8, _hoisted_53)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_42)
                        ]))
                      }), 128)),
                      (_ctx.rm.address_book.has_next && (_ctx.searchText || ``).length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                            _createElementVNode("td", _hoisted_57, [
                              _createElementVNode("div", {
                                class: "centered circle_button fw400 fs12 blueAround mt10 mb10 w100",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getMoreAddressBook && _ctx.getMoreAddressBook(...args)))
                              }, " さらに表示 ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_AttendeeEditModal, {
          currentMember: _ctx.selectedMember,
          action: `edit`,
          loading: _ctx.loading,
          onUpdate: _ctx.editAttendee
        }, null, 8, ["currentMember", "loading", "onUpdate"]),
        _createVNode(_component_ModalDeleteFromAddressBook, {
          user: _ctx.selectedMember,
          clg: _ctx.selectedClg,
          onDeleteUser: _ctx.deleteUser
        }, null, 8, ["user", "clg", "onDeleteUser"])
      ]))
    : _createCommentVNode("", true)
}